import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { UpperCasePipe } from '@angular/common';
import { PopupEditFormType, PopupTranslationFormType } from './popup-edit-form';
import { InfoPopupPlatform, VersionComparisonType } from 'src/app/base/models/models.swagger.generated';
import { DropDownListModule, MultiSelectModule } from '@syncfusion/ej2-angular-dropdowns';
import { DateTimePickerModule } from '@syncfusion/ej2-angular-calendars';
import { TabModule } from '@syncfusion/ej2-angular-navigations';

@Component({
  selector: 'app-popup-edit-form',
  templateUrl: './popup-edit-form.component.html',
  styleUrls: ['./popup-edit-form.component.scss'],
  imports: [ReactiveFormsModule, TranslateModule, UpperCasePipe, DropDownListModule, MultiSelectModule, DateTimePickerModule, TabModule]
})
export class PopupEditFormComponent implements OnInit {
  @Input() popupEditForm: FormGroup<PopupEditFormType>;

  public platformOptions: { value: number; text: string }[] = [];
  public versionComparisonOptions: { value: number; text: string }[] = [];
  public dropdownFields = { text: 'text', value: 'value' };

  public tabAnimation = {
    previous: { effect: '', duration: 0, easing: '' },
    next: { effect: '', duration: 0, easing: '' },
  };

  constructor(private translateService: TranslateService) {}

  public ngOnInit(): void {
    this.platformOptions = [
      { value: InfoPopupPlatform.Android, text: 'Android' },
      { value: InfoPopupPlatform.IOS, text: 'iOS' }
    ];

    this.versionComparisonOptions = [
      { value: VersionComparisonType.Exact, text: this.translateService.instant('i18n.domain.popups.enums.version-comparison.exact') },
      { value: VersionComparisonType.GreaterThan, text: this.translateService.instant('i18n.domain.popups.enums.version-comparison.greaterThan') },
      { value: VersionComparisonType.LessThan, text: this.translateService.instant('i18n.domain.popups.enums.version-comparison.lessThan') }
    ];
  }

  public get translationsArray(): FormArray<FormGroup<PopupTranslationFormType>> {
    return this.popupEditForm.controls.translations;
  }
}
